// Library Imports
import { faMapMarkerAlt, faPhone } from "@fortawesome/free-solid-svg-icons";
// Components
import { Button } from "../../button/Button";
// Functions, Helpers, and Utils
import openPhoneDialer from "../../../functions/openPhoneDialer";
import openMaps from "../../../functions/openMaps";
import { Locale, getLocalization } from "../../../helpers/localization";
// Assets
import TacoImage from "../../../assets/images/food/tacos-1.webp";
const FinalCallToAction: React.FC<{ deviceLanguage: Locale }> = ({
  deviceLanguage,
}) => {
  return (
    <section className="final-call-to-action padding-left-and-right padding-top-40 padding-bottom-40">
      <div className="final-call-to-action-text display-flex flex-direction-column justify-content-center align-items-left">
        <h2 className="padding-bottom-20">
          {getLocalization("home", "finalCallToActionText", deviceLanguage)}
        </h2>
        <p>
          {getLocalization(
            "home",
            "finalCallToActionDescription",
            deviceLanguage
          )}
        </p>

        <div className="button-container padding-top-40 display-flex gap-20">
          <Button
            text={getLocalization("shared", "placeOrder", deviceLanguage)}
            variant="neutral"
            buttonSize="medium"
            icon={faPhone}
            leftIcon
            onClickHandler={openPhoneDialer}
          />
          <Button
            text={getLocalization("shared", "takeMeThere", deviceLanguage)}
            variant="primary"
            buttonSize="medium"
            icon={faMapMarkerAlt}
            leftIcon
            onClickHandler={openMaps}
          />
        </div>
      </div>
      <div className="final-call-to-action-image display-flex justify-content-right">
        <img src={TacoImage} alt="Tacos" />
      </div>
    </section>
  );
};

export default FinalCallToAction;
